module.exports = __webpack_public_path__ + "media/couriers/venipak-logo-a7d6f62c.png";